import { Mail, Phone } from "lucide-react";
import React from "react";

/**
 * CarpenterHeroSilhouetteA3.jsx
 * - Uses your uploaded local file as the background (blurred/desaturated + warm wash)
 * - Right-side shows a premium 3D-ish shadow silhouette (SVG data-uri)
 * - Pure CSS only (no JS), responsive
 *
 * Local image used as background (from your upload):
 * /mnt/data/Screenshot 2025-11-16 151004.png
 */
const HERO_BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";


export default function HeroCard27() {
  return (
    <>
      <header className="chs-hero" role="banner" aria-label="Carpenter hero">
        {/* background image (local path used) */}
        <div
          className="chs-bg"
          style={{ backgroundImage: `url('${HERO_BG}')` }}
          aria-hidden="true"
        />

        {/* warm overlay + desaturation to ensure privacy */}
        <div className="chs-wash" aria-hidden="true" />

        <div className="chs-inner">
          {/* Left content */}
          <div className="chs-left">
            <div className="chs-eyebrow">WELCOME TO CARPENTER</div>

            <h1 className="chs-title">
              We Provide Best Carpenter & <br />
              <span>Wooden Service</span>
            </h1>

            <p className="chs-desc">
              Te obtinuit ut adepto satis somno. Aliisque institoribus iter deliciae
              vivet vita. Nam exempli gratia, quotiens ego vadam ad diversorum.
            </p>

            <div className="chs-actions">
              <a className="chs-btn" href="#readmore" aria-label="Read more">
                <span>Read More</span>
                <span className="arrow">➤</span>
              </a>

              <div className="chs-indicators" aria-hidden>
                <span className="dot-cm-hc27" />
                <span className="dot-cm-hc27 active" />
                <span className="dot-cm-hc27" />
              </div>
            </div>
          </div>

          {/* Right silhouette (safe) */}
          <aside className="chs-right" aria-hidden>
            <img
              src={"https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"}
              alt=""
              className="chs-silhouette"
              role="presentation"
            />
          </aside>
        </div>

        {/* bottom info bar */}
        <div className="chs-info">
          <div className="info-left">
            <div className="info-item">
              <div className="i"><Phone size={20} color={"rgba(230, 185, 125, 1)"}/></div>
              <div>
                <div className="label">PHONE</div>
                <div className="value">+00-123-456-789</div>
              </div>
            </div>

            <div className="info-item">
              <div className="i"><Mail size={20} color={"rgba(230, 185, 125, 1)"}/></div>
              <div>
                <div className="label">EMAIL</div>
                <div className="value">carpenter@gmail.com</div>
              </div>
            </div>
          </div>

          <div className="info-right">
            <button className="get-quote">GET A QUOTE</button>
          </div>
        </div>
      </header>

      <style>{`
/* ---------------- BASE ---------------- */
.chs-hero {
  position: relative;
  min-height: 82vh;
  overflow: hidden;
  color: #fff;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}
  .info-right {top:-40px;
  display: inline-block;
  padding: 14px 34px;
  background:rgba(230, 185, 125, 1);
  color: white;
  text-decoration: none;
  font-weight: 700;
  border-radius: 2px;
  position: relative;
  box-shadow: 10px 10px 0 rgba(255,255,255,0.1); 
  transform: translateY(-20px) skewX(-20deg) translateZ(-20px);;;
  transition: transform 220ms ease, box-shadow 220ms ease;
}

.info-right:hover {
  transform: translateY(-20px)  translateX(20px) skewX(-20deg) translateZ(-20px);;;
  box-shadow: 14px 14px 0 rgba(255,255,255,0.08);
}
   .info-left {
  display: inline-block;
  padding: 14px 34px; top:-30px;
  background: #ffffff;
  color: white;
  text-decoration: none;
  font-weight: 700;
  border-radius: 2px;
  position: relative;
  box-shadow: 10px 10px 0 rgba(255,255,255,0.1); 
  transform: translateY(-20px) skewX(-20deg) translateZ(-20px);;;
  transition: transform 220ms ease, box-shadow 220ms ease;
}

.info-left:hover {
  transform: translateY(-20px)  translateX(20px) skewX(-20deg) translateZ(-20px);;;
  box-shadow: 14px 14px 0 rgba(255,255,255,0.08);
}

/* blurred background using your uploaded local file */
.chs-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center right;
  filter: blur(14px) saturate(0.5) brightness(0.85);
  transform: scale(1.03);
  z-index: 0;
}

/* warm wood-toned wash to remove recognizability and give theme */
.chs-wash {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(134,88,46,0.60), rgba(134,88,46,0.28) 55%, rgba(20,12,8,0.45));
  z-index: 1;
  pointer-events: none;
}

/* inner container */
.chs-inner {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 28px;
  max-width: 1300px;
  margin: 0 auto;
  padding: 48px 6%;
}

/* left column */
.chs-left {
  flex: 1 1 60%;
  max-width: 760px;
}

/* eyebrow small text */
.chs-eyebrow {
  letter-spacing: 6px;
  font-weight: 700;
  opacity: 0.95;
  margin-bottom: 14px;
}

/* title */
.chs-title {
  font-size: 2.6rem;
  line-height: 1.06;
  font-weight: 800;
  margin: 0 0 18px;
  color: #fff;
}
.chs-title span { color: #ffd9b0; }

/* description */
.chs-desc {
  color: rgba(255,255,255,0.88);
  max-width: 64ch;
  line-height: 1.65;
  margin-bottom: 22px;
}

/* actions row */
.chs-actions {
  display:flex;
  align-items:center;
  gap:20px;
}

/* CTA */
.chs-btn {
  display:inline-flex;
  gap:14px;
  align-items:center;
  background: rgba(0,0,0,0.18);
  padding: 12px 20px;
  border-radius: 28px;
  border: 1px solid rgba(255,255,255,0.08);
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  transition: transform .22s ease, box-shadow .22s ease;
}
.chs-btn:hover { transform: translateY(-6px); background:rgba(230, 185, 125, 1); box-shadow: 0 18px 40px rgba(0,0,0,0.28); }
.chs-btn .arrow {
  background: #111;
  color: #ffd9b0;
  width: 40px; height: 40px;
  border-radius: 50%;
  display:grid; place-items:center;
}

/* indicators */
.chs-indicators { display:flex; gap:8px; align-items:center; }
.chs-indicators .dot-cm-hc27 { width:10px; height:10px; border-radius:50%; background: rgba(255,255,255,0.35); }
.chs-indicators .dot-cm-hc27.active { background: rgba(255,255,255,0.98); }

/* right silhouette */
.chs-right {
  flex: 0 0 36%;
  display:flex;
  align-items:center;
  justify-content:center;
}
.chs-silhouette {
  
  min-width: 100%;
  filter: drop-shadow(0 24px 60px rgba(0,0,0,0.32));
  transform: translateY(0);
  animation: bob 5s ease-in-out infinite;
}

/* subtle bob animation */
@keyframes bob {
  0% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0); }
}

/* bottom info bar */
.chs-info {
  position: absolute;
  left: 0; right: 0; bottom: 0;
  z-index: 3;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:12px;
  padding: 16px 6%;
  background: rgba(255,255,255,0.96);
  box-shadow: 0 -12px 30px rgba(0,0,0,0.04);
  color: #2b1a0f;
}
.info-left { display:flex; gap:18px; align-items:center; }
.info-item { display:flex; gap:12px; align-items:center; }
.info-item .i { width:44px;height:44px; border-radius:10px; display:grid; place-items:center; background: rgba(97,61,29,0.06); font-size:20px; }
.label { font-size:0.75rem; color:#8a6b53; font-weight:700; }
.value { font-weight:700; color:#2b1a10; }

/* get quote */
.get-quote {
  background:#ffffff;
  color: #b97f4a;
  padding: 12px 22px;
  border-radius: 6px;
  border: none;
  font-weight:800;
  cursor:pointer;
}

/* responsive */
@media (max-width: 980px) {
  .chs-inner { flex-direction: column-reverse; gap: 20px; padding: 28px 6%; }
  .chs-right { width: 100%; }
  .chs-silhouette { width: 320px; }
  .chs-info { flex-direction: column; gap:8px; align-items:stretch; text-align:center; }
}

@media (max-width: 520px) {
  .chs-title { font-size: 1.6rem; }
  .chs-silhouette { width: 260px; }
  .chs-desc { font-size: 0.95rem; }
  .chs-btn .arrow { width: 36px; height:36px; }
}
      `}</style>
    </>
  );
}
